import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import type { Role } from "@aurelia/types";
import { useAuthStore } from "../lib/stores/auth";

export function ProtectedRoute({ role, children }: PropsWithChildren<{ role?: Role | Role[] }>) {
  const { user, status } = useAuthStore();

  if (status === "idle" || status === "loading") {
    return <div className="min-h-screen flex items-center justify-center text-ink-muted">Loading…</div>;
  }

  if (!user) return <Navigate to="/login" replace />;

  if (role) {
    const allowed = Array.isArray(role) ? role.includes(user.role) : user.role === role;
    if (!allowed) return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
